import React from "react";
import { ShieldCheck } from "lucide-react";
import FunnelAssessmentViewerV2Base from "./FunnelAssessmentViewerV2Base";

const FunnelOperationalReadinessAssessmentViewerV2 = ({ markdown }) => (
  <FunnelAssessmentViewerV2Base
    markdown={markdown}
    title="Operational Readiness & Data Confidence"
    subtitle="Scalability signal from operations and data integrity"
    badge="Operations"
    Icon={ShieldCheck}
  />
);

export default FunnelOperationalReadinessAssessmentViewerV2;
